exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".promotion_links_area .promotion_links_select_area .select_list .select_item {\n  text-align: center;\n  font-size: 1.124rem;\n  letter-spacing: 2.4px;\n  color: #9b9b9b;\n  cursor: pointer;\n}\n.promotion_links_area .promotion_links_block {\n  margin: 2rem 0;\n}\n.promotion_links_area .promotion_links_block .promotion_links_item {\n  height: 60px;\n  border-radius: 4px;\n  box-shadow: 5px 5px 14px 0 rgba(0, 0, 0, 0.1);\n  background-color: #fff;\n  display: block;\n  margin: 0 0.5rem 2rem;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}", ""]);

// exports
